"use strict";var _constants=require("./constants");Object.defineProperty(exports,"__esModule",{value:!0}),exports.cpfToApi=cpfToApi,exports.cepToApi=cepToApi,exports.stateToUf=stateToUf,exports.ufToState=ufToState,exports.dateToApi=dateToApi,exports.nameToApi=nameToApi,exports.onlyDdd=onlyDdd,exports.onlyPhoneNumber=onlyPhoneNumber,exports.phoneNumberToApi=phoneNumberToApi,exports.floatToBrl=floatToBrl;/**
 * Convert a CPF in the format "000.000.000-99" to "00000000000"
 *
 * @param {String} cpf The CPF to be converted
 * @returns  The converted CPF
 */function cpfToApi(a){return null===a||void 0===a?void 0:a.replace(".","").replace(".","").replace("-","")}/**
 * Convert a CEP in the format "00000-000" to "00000000"
 *
 * @param {String} cpf The CEP to be converted
 * @returns  The converted CEP
 */function cepToApi(a){return null===a||void 0===a?void 0:a.replace("-","")}/**
 * Convert a state in the format "São Paulo (SP)" to "SP"
 *
 * @param {String} state The state with the UF already included in the end
 * @returns The UF of the given state
 */function stateToUf(a){return null===a||void 0===a?void 0:a.substring(a.length-3,a.length-1)}/**
 * Convert a UF to a state object containing value and label
 * the value is the UF and the label is composed by the full
 * name of the state plus the uf
 *
 * Input format:
 * - SP
 * - PB
 * - CE
 *
 * @param {String} uf The UF to be converted
 * @returns An object representing the state {value, label}
 */function ufToState(a){return _constants.states.find(function(b){return b.value===a})}/**
 * Convert a date in the format "DD/MM/YYYY" to "YYYY-MM-DD"
 *
 * @param {String} date The date to be converted
 * @returns The converted date
 */function dateToApi(a){var b=null===a||void 0===a?void 0:a.substring(6,11),c=null===a||void 0===a?void 0:a.substring(3,5),d=null===a||void 0===a?void 0:a.substring(0,2);return b+"-"+c+"-"+d}/**
 * Remove white spaces before and after a name and uppercase all the
 * letters of the name
 *
 * @param {String} name The name to be converted
 * @returns The converted name
 */function nameToApi(a){return null===a||void 0===a?void 0:a.trim().toUpperCase()}/**
 * Extract the DDD from a given DDD + phone number
 *
 * Input format:
 * "(12) 34567-8910"
 *
 * Ouput format:
 * "12"
 *
 * @param {String} pn The DDD + phone number
 * @returns The extracted DDD
 */function onlyDdd(a){return null===a||void 0===a?void 0:a.substring(1,3)}/**
 * Extract the phone number from a given DDD + phone number
 *
 * Input format:
 * "(12) 34567-8910"
 *
 * Ouput format:
 * "345678910"
 *
 * @param {String} pn The DDD + phone number
 * @returns The extracted phone number
 */function onlyPhoneNumber(a){return null===a||void 0===a?void 0:a.substring(5).replace("-","")}/**
 * Convert a DDD + phone number in the format "(12) 34567-8910" to "{
 *  ddd: 12,
 *  numero: 345678910
 * }"
 *
 * @param {String} pn The DDD + phone number to be converted
 * @returns An object containing {ddd, numero}
 */function phoneNumberToApi(a){return{ddd:onlyDdd(a),numero:onlyPhoneNumber(a)}}/**
 * Convert a string represeting a float value to BRL currency.
 *
 * Input format:
 * "99.99"
 *
 * Output format:
 * "R$ 99,99"
 *
 * @param {String} value The string representing the value
 * @param {Boolean} prefix Whether the R$ prefix should be included or not. Default: True
 * @returns A string representing the value in BRL
 */function floatToBrl(a){var b=!(1<arguments.length&&arguments[1]!==void 0)||arguments[1],c=null===a||void 0===a?void 0:a.toLocaleString("pt-BR",{style:"currency",currency:"BRL"});return b?c:c.substring(3)}